const register = {
    data() { 
      return {  
        
        registerData: { 
          FirstName: null,
          LastName: null,
          Email: null,
          AvatarUrl: null,
          UserName: null,
          Password: "Mzn657**",
          ConfirmPassword: "Mzn657**",
          }, 
          
      }
    }, 
 
}
export default register